import styled from 'styled-components';

export const MenuContainer = styled.div`
  --top: min(5.164vmax, 45px);

  padding-inline: min(6.282vmin, 25px);
  height: calc(var(--top) + 60px);
  padding-top: var(--top);

  position: fixed;
  display: block;

  width: 100%;
  z-index: 2;
  top: 0px;

  > button:first-child {
    margin-inline: auto 0px;
  }

  dialog:first-child > img:first-child {
    background-color: #7d3995;
  }
`;

export const MenuContent = styled.div`
  transform: translateY(-1px);
  background-color: white;
  padding: 22px 63px 39px;

  > button {
    max-width: fit-content;
    min-width: 200px;
    width: fit-content;
  }

  > button:first-child {
    white-space: nowrap;
  }

  > button:nth-child(2) {
    margin-top: 15px;

    > svg:first-child {
      translate: 0px -1px;
      margin-right: 9px;
    }
  }

  > button:nth-child(3) {
    margin-top: 15px;
  }

  > a:last-child {
    margin: 40px auto 0px;
    position: relative;
    font-weight: bold;

    display: table;
    color: black;

    right: 0px;
    left: 0px;
  }
`;
